<template>
  <div class="d-flex justify-center flex-wrap">
    <v-hover v-slot="{ hover }">
      <v-card :elevation="hover ? 12 : 2">
        <v-card-title class="justify-center">Адрес и телефон</v-card-title>
        <v-divider></v-divider>
        <a href="https://yandex.ru/profile/127822682088" target="_blank">
          <v-card-text> <b>Адрес:</b> Глазов, Калинина,2а(3 этаж) </v-card-text></a
        >
        <a href="tel:+79068970429"
          ><v-card-text> <b>Телефон:</b> 8 906 897-04-29 </v-card-text></a
        >
      </v-card>
    </v-hover>
    <v-hover v-slot="{ hover }">
      <v-card :elevation="hover ? 12 : 2">
        <v-card-title class="justify-center">Социальные сети</v-card-title>
        <v-divider></v-divider>
        <a href="https://vk.com/qbitclub" target="_blank">
          <v-card-text>
            <v-icon large> mdi-vk </v-icon> ВКонтакте
          </v-card-text></a
        >
        <a href="https://www.instagram.com/qbit_club/?hl=ru" target="_blank">
          <v-card-text>
            <v-icon large> mdi-instagram </v-icon> Instagram
          </v-card-text></a
        >
        <a href="https://t.me/grachevrv" target="_blank">
          <v-card-text>
            <v-icon large> mdi-telegram </v-icon> Telegram
          </v-card-text></a
        >
      </v-card>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: "Contacts",
};
</script>

<style lang="scss" scoped>
.v-card {
  text-align: center;
  margin: 20px;
  max-width: 500px;
  min-width: 280px;
}
a {
  text-decoration: none;
}
.v-application a {
  color: rgba(0, 0, 0, 0.6);
}
.v-card__text:hover {
  color: black;
  .mdi:before {
    color: black;
  }
}
</style>